// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1511":"e35e4fc0","2940":"74f24baa","4832":"e72b3529","7908":"6f49aea2","8759":"9cb3ce37"}[chunkId] + ".chunk.css";
};